import type { MailContentProps, MailMetadata } from "../../lib/types";
import { calculateDateWithDateRelative } from "../../lib/utils";
import { MailSignature } from "../mail/mail-signature";

function JourneeManagementADistance({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_actuel_nom},
      </p>
      <p>
        Nous avions sollicité votre prédécesseur,{" "}
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom}, pour intervenir
        dans le cadre de notre «<span> Journée Management à distance</span> »
        sur le thème : «
        <span className="font-normal italic">
          Optimiser la mobilisation et l'engagement des collaborateurs via une
          stratégie RSE (projet transverse, implication par les valeurs
          partagées…)
        </span>
        ».
      </p>
      <p>
        Cette journée se tient le{" "}
        <span>
          {calculateDateWithDateRelative(
            Number(variablesData.conference_cci_date) || 0,
          )}
        </span>{" "}
        à Nancy dans nos locaux.
      </p>
      <p>
        L'intervention prévue est de 20 mn, elle sera suivie d'une table ronde.
      </p>
      <p>
        Étant donné que l'échéance se rapproche, nous souhaiterions savoir si
        vous pouvez intervenir sur ce sujet.
      </p>
      <p>
        Nous sommes, bien entendu, fort intéressés par votre témoignage sur les
        expériences menées au sein de {variablesData.societe_nom}.
      </p>
      <p>
        Nous comptons vivement sur votre participation qui sera également pour
        vous l'occasion de rencontrer la plupart des Responsables
        socio-économiques et politiques de la Région.
      </p>
      <p>
        Nous vous prions, Monsieur le Responsable, d'agréer l'expression de
        notre parfaite considération.
      </p>
      <MailSignature
        emetteurLogo={JourneeManagementADistance.metadata.emetteurLogo}
        emetteur={JourneeManagementADistance.metadata.emetteur}
        emetteurPoste={JourneeManagementADistance.metadata.emetteurPoste}
        emetteurEntreprise={
          JourneeManagementADistance.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

JourneeManagementADistance.metadata = {
  titre: "Journée Management à distance",
  cleMail: "journee_management_distance",
  messageTransfert: false,
  emetteur: "Mathieu Berger",
  emetteurPoste: "Responsable Formation",
  emetteurEntreprise: "Chambre du Commerce et de l'Industrie",
  emetteurLogo: "/logos/cci.jpg",
  dateRelative: -4,
  piecesJointes: [],
} as MailMetadata;

export default JourneeManagementADistance;
